export interface Character {
  slug: string;
  name: string;
  nameJa: string;
  role: string;
  description: string;
  voiceActor: string;
  image: string;
  traits: string[];
}

export const characters: Character[] = [
  {
    slug: 'ako',
    name: '住之江亚香',
    nameJa: '住之江 亜香',
    role: '双胞胎姐姐 / 学生会会长',
    description: '成绩优异、性格温柔体贴的双胞胎姐姐。总是以姐姐的身份默默守护着圭太，但在温柔的外表下隐藏着对圭太炽热的感情。擅长料理和家务，是理想中的完美姐姐形象。',
    voiceActor: '竹达彩奈',
    image: 'https://readdy.ai/api/search-image?query=Anime%20girl%20with%20long%20silky%20dark%20brown%20hair%2C%20gentle%20warm%20smile%2C%20Japanese%20school%20uniform%2C%20soft%20pink%20cherry%20blossom%20background%2C%20elegant%20pose%2C%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20anime%20art%20style&width=400&height=500&seq=character-ako&orientation=portrait',
    traits: ['温柔', '体贴', '成绩优秀', '擅长料理', '外柔内刚'],
  },
  {
    slug: 'riko',
    name: '住之江理香',
    nameJa: '住之江 理香',
    role: '双胞胎妹妹 / 运动系少女',
    description: '活泼开朗、运动神经发达的双胞胎妹妹。性格直率大胆，从不掩饰对圭太的喜欢。虽然有时候过于冲动，但那份真诚的心意感染着身边的每一个人。',
    voiceActor: '佐藤聪美',
    image: 'https://readdy.ai/api/search-image?query=Anime%20girl%20with%20twin%20tails%20and%20bright%20smile%2C%20energetic%20pose%2C%20Japanese%20school%20sports%20uniform%2C%20sunny%20school%20field%20background%2C%20warm%20golden%20lighting%2C%20cheerful%20vibe%2C%20anime%20art%20style&width=400&height=500&seq=character-riko&orientation=portrait',
    traits: ['活泼', '直率', '运动达人', '大胆', '真诚'],
  },
  {
    slug: 'keita',
    name: '住之江圭太',
    nameJa: '住之江 圭太',
    role: '男主角 / 高中生',
    description: '普通的高中生，与没有血缘关系的双胞胎姐姐亚香和理香住在一起。性格温柔但有些优柔寡断，在两位姐姐的爱意中摇摆不定，但内心深处真心关心着她们。',
    voiceActor: '武内健',
    image: 'https://readdy.ai/api/search-image?query=Anime%20boy%20with%20short%20brown%20hair%2C%20gentle%20kind%20eyes%2C%20Japanese%20high%20school%20uniform%2C%20slightly%20embarrassed%20expression%2C%20school%20classroom%20background%2C%20warm%20afternoon%20light%2C%20anime%20art%20style&width=400&height=500&seq=character-keita&orientation=portrait',
    traits: ['温柔', '善良', '优柔寡断', '认真', '成长中'],
  },
  {
    slug: 'mikazuki',
    name: '三日月夜空',
    nameJa: '三日月 夜空',
    role: '同班同学',
    description: '圭太的同班同学，性格冷静沉稳。虽然没有直接参与主线恋情，但作为旁观者和朋友，她的存在为故事增添了不少有趣的互动。',
    voiceActor: '井口裕香',
    image: 'https://readdy.ai/api/search-image?query=Anime%20girl%20with%20short%20dark%20hair%2C%20calm%20expression%2C%20Japanese%20school%20uniform%2C%20standing%20in%20school%20library%2C%20quiet%20atmosphere%2C%20soft%20lighting%20from%20window%2C%20anime%20art%20style&width=400&height=500&seq=character-mikazuki&orientation=portrait',
    traits: ['冷静', '聪明', '观察力强', '毒舌', '可靠'],
  },
];